import addressApi from '../../../services/addressApi';
import logger from '../../../utils/logger';
import { extrairRegistrosCep } from '../utils/cepRegistros';

export const addressService = {

  // Devolve a resposta do axios com `data.data` sempre como array de registros
  // (ver extrairRegistrosCep: aceita o formato antigo, objeto único, e o novo).
  async getByCEP(cep) {
    try {
      logger.log(`📫 Buscando CEP: ${cep}`);

      const response = await addressApi.get(`/cep/${cep}`);

      return {
        ...response,
        data: { ...response.data, data: extrairRegistrosCep(response) }
      };
    } catch (error) {
      logger.error('❌ Erro ao buscar CEP:', error);
      throw error;
    }
  },

  async getStates() {
    try {
      const response = await addressApi.get('/estados');

      return {
        ...response,
        data: response.data.data.map(e => ({
          id: e.id,
          nome: e.descricao,
          sigla: e.sigla
        }))
      };
    } catch (error) {
      logger.error('❌ Erro ao buscar estados:', error);
      throw error;
    }
  },


  async getCities(estadoId) {
    try {
      const response = await addressApi.get(
        `/estados/${estadoId}/municipios`
      );

      return {
        ...response,
        data: response.data.data.map(m => ({
          id: m.id,
          nome: m.municipio,
          estadoId
        }))
      };
    } catch (error) {
      logger.error('❌ Erro ao buscar municipios:', error);
      throw error;
    }
  },


  async getCountries() {
    try {
      const response = await addressApi.get('/paises');

      return {
        ...response,
        data: response.data.data.map(p => ({
          id: p.id,
          nome: p.descricao,
          sigla: p.sigla
        }))
      };
    } catch (error) {
      logger.error('❌ Erro ao buscar países:', error);
      throw error;
    }
  },

  // Busca municípios pelo nome em qualquer estado (ex: campo Naturalidade).
  // A API só devolve o nome completo do estado, então resolvemos a sigla
  // usando a lista de estados já carregada (evita outra chamada de API).
  async searchCities(query, estados = []) {
    try {
      const response = await addressApi.get('/municipios/busca', {
        params: { q: query }
      });

      return {
        ...response,
        data: response.data.data.map(m => {
          const estado = estados.find(
            e => e.nome.toLowerCase() === String(m.estado).toLowerCase()
          );

          return {
            id: m.id,
            nome: m.municipio,
            estadoSigla: estado ? estado.sigla : m.estado
          };
        })
      };
    } catch (error) {
      logger.error('❌ Erro ao buscar municípios:', error);
      throw error;
    }
  },

};